import { useEffect, useContext } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import { MapContext } from '../../../contexts/MapContext';

/**
 * Botão nativo do Leaflet para resetar o zoom para a visão inicial do Brasil
 * Props: initialCenter (array), initialZoom (number)
 */
const ResetZoomButton = ({ initialCenter = [-15.77972, -47.92972], initialZoom = 4 }) => {
  const map = useMap();
  // Desestruturar setters do contexto para limpar estados ao resetar zoom
  const {
    setMarker,
    setGeometries,
    setThemeGeometries,
    setActiveLayers,
    setPropertyData,
    setSidebarOpen,
  } = useContext(MapContext);

  useEffect(() => {
    // Controle customizado
    const resetControl = L.Control.extend({
      options: { position: 'topleft' },
      onAdd: function () {
        const container = L.DomUtil.create('div', 'leaflet-bar leaflet-control reset-zoom-button');
        // Ícone de globo
        container.innerHTML = '🌐';
        container.title = 'Resetar zoom para visão inicial';
        container.style.fontSize = '20px';
        container.style.background = 'white';
        container.style.padding = '2px 6px';
        container.style.borderRadius = '4px';
        container.style.display = 'flex';
        container.style.alignItems = 'center';
        container.style.justifyContent = 'center';
        container.style.cursor = 'pointer';
        L.DomEvent.on(container, 'click', function (e) {
          L.DomEvent.stopPropagation(e);
          L.DomEvent.preventDefault(e);
          // Resetar zoom para visão inicial
          map.setView(initialCenter, initialZoom, { animate: true });
          // Limpar estados para remover o marcador e dados associados
          setMarker(null);
          setGeometries([]);
          setThemeGeometries({});
          setActiveLayers({});
          setPropertyData(null);
          setSidebarOpen(false);
        });
        return container;
      },
    });
    const control = new resetControl();
    map.addControl(control);
    return () => {
      map.removeControl(control);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map, initialCenter, initialZoom]);
  return null;
};

export default ResetZoomButton;
